import { SortingState } from "@tanstack/react-table";
import { ApiArchiveFilterParams } from "griptonite-api-client";
import { snakeCase } from "snake-case";

import { FilterParams } from "../RoutesTable/useFilteredRoutes";
import { multiChoiceSetToArrayParam } from "./ArchiveRoutesTable";

function getSortParam(sortState: SortingState) {
  return sortState
    .map((sort) => {
      return `${sort.desc ? "-" : ""}${snakeCase(sort.id)}`;
    })
    .join(",");
}

export const convertArchiveSortFilterParamsToBackend = (
  params: Partial<FilterParams>,
  sortState: SortingState,
): ApiArchiveFilterParams => {
  const circuitsArray = multiChoiceSetToArrayParam(params.circuit);
  const circuits = circuitsArray?.filter((x) => x.startsWith("circuit:")).map((x) => x.slice(8));
  const competitions = circuitsArray
    ?.filter((x) => x.startsWith("competition:"))
    .map((x) => x.slice(12));

  return {
    zones: multiChoiceSetToArrayParam(params.zone),
    minGradeValue: params.grade?.min,
    maxGradeValue: params.grade?.max,
    gradeSystem: params.grade?.system,
    setters: multiChoiceSetToArrayParam(params.setters),
    minStarRating: params.starRating?.min,
    maxStarRating: params.starRating?.max,
    circuits,
    competitions,
    startLines: multiChoiceSetToArrayParam(params.startLine),
    styles: multiChoiceSetToArrayParam(params.styles),
    skills: multiChoiceSetToArrayParam(params.skills),
    holds: multiChoiceSetToArrayParam(params.holds),
    holdColors: multiChoiceSetToArrayParam(params.holdColors),
    ascentStyle: multiChoiceSetToArrayParam(params.ascentStyle),
    isExComp: params.isExComp,
    minStartTime: params.startTime?.min,
    maxStartTime: params.startTime?.max,
    minEndTime: params.endTime?.min,
    maxEndTime: params.endTime?.max,
    sort: getSortParam(sortState),
  };
};
